/*
  cm-cart.js · motor del carrito lateral Del Bosque (sections/cm-cart-drawer.liquid). JS vanilla, sin dependencias.
  Adaptado de $KIT/patterns/assets/cm-cart.js.
    - Agregar por AJAX: cualquier <form data-cm-ajax> (form de producto, upsell del drawer, sticky con form="…").
      /cart/add.js con `sections` → el HTML nuevo del drawer llega en la misma respuesta (Section Rendering API).
      Sin drawer en la página → submit nativo.
    - Cantidad / eliminar: /cart/change.js por número de línea.
    - Contador: todo [data-cm-cart-count] se actualiza (y se oculta en 0).
    - Abrir: clic en [data-cm-cart-open] (ej. <a href="/cart"> del header; preventDefault solo si existe el drawer).
    - Eventos: dispara `cm:cart-updated` {cart, source} y, para componentes de Tinker que sigan en la página (/cart),
      `cart:update` {resource, sourceId:'cm', data:{itemCount, source:'cm'}}.
      Escucha `cart:update` de Tinker (quick-add / product-form-component): refresca el drawer y lo abre si fue un add.
    - API: window.CmCart.open() / close() / refresh() / add(formData | {id, quantity}) / change(line, qty).
*/
(function () {
  if (window.CmCart) return;

  var STATUS_TEXT = { added: 'Producto agregado al carrito', updated: 'Carrito actualizado', error: 'No se pudo actualizar el carrito' };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function el() { return document.querySelector('cm-cart-drawer'); }
  function dialog() { var d = el(); return d && d.querySelector('[data-cm-cart-dialog]'); }
  function sectionId() { var d = el(); return d && d.dataset.sectionId; }

  function handle(r) {
    return r.json().then(function (data) {
      if (!r.ok || data.status) throw new Error(data.description || data.message || STATUS_TEXT.error);
      return data;
    });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function setCount(n) {
    document.querySelectorAll('[data-cm-cart-count]').forEach(function (c) {
      c.textContent = n;
      c.hidden = String(n) === '0';
    });
  }

  // Reemplaza el cuerpo del drawer con el HTML de la sección y restaura el foco en el control equivalente.
  function render(html) {
    var d = el(); if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cm-cart-body]');
    var body = d.querySelector('[data-cm-cart-body]');
    if (!fresh || !body) return;
    var a = document.activeElement, key = null;
    if (a && body.contains(a) && a.dataset && a.dataset.line) {
      key = (a.hasAttribute('data-cm-remove') ? '[data-cm-remove]' : '[data-cm-qty="' + a.dataset.cmQty + '"]') + '[data-line="' + a.dataset.line + '"]';
    }
    var scroller = body.querySelector('.cm-cart__scroll');
    var scrollTop = scroller ? scroller.scrollTop : 0;
    body.innerHTML = fresh.innerHTML;
    var newScroller = body.querySelector('.cm-cart__scroll');
    if (newScroller) newScroller.scrollTop = scrollTop;
    var count = body.querySelector('[data-cm-cart-count-value]');
    if (count) setCount(count.dataset.cmCartCountValue);
    // Si el foco estaba dentro del drawer (y se perdió al reemplazar el HTML), lo devolvemos al control equivalente.
    if (dialog() && dialog().open && (key || !document.contains(a) || a === document.body)) {
      var target = (key && body.querySelector(key)) || body.querySelector('[data-cm-cart-close]');
      if (target) target.focus({ preventScroll: true });
    }
  }

  function status(msg) {
    var s = el() && el().querySelector('[data-cm-cart-status]');
    if (s) { s.textContent = ''; setTimeout(function () { s.textContent = msg; }, 50); }
  }
  function busy(on) { var dl = dialog(); if (dl) dl.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function emit(cart, source) {
    document.dispatchEvent(new CustomEvent('cm:cart-updated', { detail: { cart: cart, source: source } }));
    // Puente para componentes de Tinker (página /cart, burbujas): sourceId 'cm' para no entrar en bucle.
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'cm', data: { itemCount: cart && cart.item_count, source: 'cm' } },
      }));
    } catch (e) { /* noop */ }
  }

  var opener = null;
  var CmCart = {
    open: function () {
      var dl = dialog(); if (!dl) return false;
      if (!dl.open) {
        opener = document.activeElement;
        dl.showModal();
        document.documentElement.classList.add('cm-scroll-lock');
        var close = dl.querySelector('[data-cm-cart-close]');
        if (close) close.focus({ preventScroll: true });
      }
      return true;
    },
    close: function () { var dl = dialog(); if (dl && dl.open) dl.close(); },
    // Re-render sin cambios (ej. después de que una app o Tinker modificó el carrito).
    refresh: function (source) {
      var id = sectionId(); if (!id) return Promise.resolve();
      return fetch(root + '?sections=' + encodeURIComponent(id))
        .then(function (r) { return r.json(); })
        .then(function (s) { render(s[id]); return getCart(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cm:cart-updated', { detail: { cart: cart, source: source || 'refresh' } }));
          return cart;
        });
    },
    add: function (input) {
      var id = sectionId();
      var formData = input;
      if (!(input instanceof FormData)) {
        formData = new FormData();
        formData.append('id', input.id);
        formData.append('quantity', input.quantity || 1);
      }
      if (id) { formData.append('sections', id); formData.append('sections_url', window.location.pathname); }
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
        .then(handle)
        .then(function (item) {
          if (item.sections && id) render(item.sections[id]);
          var d = el();
          if (!d || d.dataset.openOnAdd !== 'false') CmCart.open();
          status(STATUS_TEXT.added);
          return getCart().then(function (cart) { setCount(cart.item_count); emit(cart, 'add'); return item; });
        });
    },
    change: function (line, quantity) {
      var id = sectionId();
      busy(true);
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: id ? [id] : [], sections_url: window.location.pathname }),
      })
        .then(handle)
        .then(function (cart) {
          if (cart.sections && id) render(cart.sections[id]);
          setCount(cart.item_count);
          status(STATUS_TEXT.updated);
          emit(cart, 'change');
          return cart;
        })
        .catch(function (e) { status(e.message || STATUS_TEXT.error); return CmCart.refresh(); })
        .finally(function () { busy(false); });
    },
  };
  window.CmCart = CmCart;

  // Submit de forms marcados con data-cm-ajax (incluye botones externos con form="id").
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-cm-ajax]') || !el()) return;
    if (e.defaultPrevented) return; // otra app (ej. Releasit) ya tomó el submit
    e.preventDefault();
    var fd;
    try { fd = new FormData(form, e.submitter); } catch (err) { fd = new FormData(form); if (e.submitter && e.submitter.name) fd.append(e.submitter.name, e.submitter.value); }
    var btns = form.id ? [].slice.call(document.querySelectorAll('[form="' + form.id + '"][type="submit"]')) : [];
    btns = btns.concat([].slice.call(form.querySelectorAll('[type="submit"]')));
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var err = form.querySelector('[data-cm-form-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    CmCart.add(fd)
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } else { status(ex.message); console.warn('[cm-cart]', ex.message); } })
      .finally(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
  });

  // Clics: abrir / cerrar / cantidades / eliminar / backdrop.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var openBtn = t.closest('[data-cm-cart-open]');
    if (openBtn && dialog()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return; // abrir /cart en otra pestaña
      e.preventDefault();
      CmCart.open();
      return;
    }
    var d = el();
    if (!d || !d.contains(t)) return;
    if (t.closest('[data-cm-cart-close]')) { CmCart.close(); return; }
    var q = t.closest('[data-cm-qty]');
    if (q && !q.disabled) { e.preventDefault(); CmCart.change(q.dataset.line, q.dataset.cmQty); return; }
    if (t === dialog()) CmCart.close();
  });

  // Al cerrar: libera el scroll y devuelve el foco al disparador.
  document.addEventListener('close', function (e) {
    if (e.target !== dialog()) return;
    document.documentElement.classList.remove('cm-scroll-lock');
    if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }, true);

  // Carrito modificado por Tinker (quick-add, product-form-component, página /cart) u otras apps que usen su evento.
  document.addEventListener('cart:update', function (e) {
    var det = e.detail || {};
    if (det.sourceId === 'cm') return;
    var data = det.data || {};
    if (!el()) return;
    CmCart.refresh('tinker').then(function () {
      if (data.source === 'product-form-component' && !data.didError) {
        var d = el();
        if (d && d.dataset.openOnAdd !== 'false') CmCart.open();
      }
    });
  });

  // Volver con "atrás" (bfcache) puede mostrar un carrito viejo.
  window.addEventListener('pageshow', function (e) { if (e.persisted) CmCart.refresh(); });
})();
